import React, { Component } from "react";
import { Card, Form, Input, Select, message, Button } from "antd";
import { connect } from "react-redux";
import { req_add_nms_noteproject } from "../../api";

const { Option } = Select;

class AddNotebooklmModal extends Component {
  formRef = React.createRef();

  handleOk = () => {
    this.formRef.current
      .validateFields()
      .then(async (values) => {
        const { token, userCode } = this.props.user;
        const item = {
          ...values,
          AuthorId: userCode,
          NoteStatusCode: "OPEN",
        };

        try {
          await req_add_nms_noteproject(item, token);
          message.success("新增成功");
          this.formRef.current.resetFields();
        } catch (error) {
          message.error("新增失敗: " + error);
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Card>
        <Form
          {...formItemLayout}
          ref={this.formRef}
          name="add-notebooklm-form"
          onFinish={this.handleOk}
        >
                    <Form.Item
            name="LmUrl"
            label="筆記連結"
            rules={[{ required: true, message: "請輸入筆記連結!", type: 'url' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="NoteTitle"
            label="筆記名稱"
            rules={[{ required: true, message: "請輸入筆記名稱!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="NoteDescription"
            label="筆記說明"
            rules={[{ required: true, message: "請輸入筆記說明!" }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            name="NoteTypeCode"
            label="分類"
            initialValue="TYPE_COURSE"
            rules={[{ required: true, message: "請選擇分類!" }]}
          >
            <Select>
              <Option value="TYPE_COURSE">課程講義</Option>
              <Option value="TYPE_DOC">文件彙整</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="ApplicableDeparts"
            label="適用對象"
            initialValue="全部"
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {"送出"}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AddNotebooklmModal);
